/*
 * @Description: 客户案例页面所有路由
*/

export default [
    {
        path: 'customer',
        component: resolve => require(['@/views/customer'], resolve),
        name: 'Customer',
        meta: {
            nav: '客户案例'
        }
    }
      
]


// WEBPACK FOOTER //
// ./src/router/customer.js